import React from 'react';

import gridStyles from 'assets/style/grid.module.css';
import clsx from 'clsx';
import { useTrackPageAndSessionView } from 'js/hooks/useTrackPageAndSessionView';
import Question from './Question';
import QuestionDetails from './QuestionDetails';
import QuestionSearch from './QuestionSearch';
import Answers from './Answers';
import Sidebar from './Sidebar';

import styles from './styles.module.css';
import { Context } from '../../components/LocaleWrapper';

const QuestionPage = () => {
  useTrackPageAndSessionView();
  const { pageData, i18n, generateUri } = React.useContext(Context);
  const question = pageData.question.question;
  const answers = question.answers;
  const primaryTreatment = question.treatmentCategories[0];

  const treatmentInfo = pageData.cms.page.treatment[primaryTreatment.id];
  const treatmentFiles =
    pageData.question.treatmentTypesInspirationArticles ||
    pageData.question.treatmentInspirationArticles ||
    null;
  const popularLocations = pageData.popularLocations;

  const searchComponent = (
    <QuestionSearch
      i18n={i18n}
      treatment={primaryTreatment}
      popularLocations={popularLocations}
    />
  );

  return (
    <div className={styles.page}>
      <div className={clsx(styles.hero)}>
        <Question question={question} i18n={i18n} generateUri={generateUri} />
      </div>
      <div className={clsx(styles.wrapper, gridStyles.row)}>
        <div className={clsx(styles.pageContent, gridStyles['col-xs-12'])}>
          <div className={clsx(styles.wrapper, gridStyles.row)}>
            <div
              className={clsx(
                gridStyles['col-md-8'],
                gridStyles['col-sm-6'],
                gridStyles['col-xs-12']
              )}
            >
              <QuestionDetails
                question={question}
                i18n={i18n}
                generateUri={generateUri}
              />
              <Answers answers={answers} i18n={i18n} generateUri={generateUri}>
                {searchComponent}
              </Answers>
            </div>
            <div
              className={clsx(
                gridStyles['col-md-4'],
                gridStyles['col-sm-6'],
                gridStyles['col-xs-12'],
                styles.sidebar
              )}
            >
              <div className={styles.sidebarSearch}>{searchComponent}</div>
              <Sidebar
                question={question}
                treatmentDescription={treatmentInfo.description}
                treatmentFiles={treatmentFiles}
                i18n={i18n}
                generateUri={generateUri}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionPage;
